<template>
  <v-layout column mb10 v-if="isVisible">
    <v-flex xs12 style="max-width: 200px;">
      <!-- 銀行振込かつ learningMonthItems が渡されている場合のみ表示 -->
      <v-select
        v-if="showLearningMonths"
        name="learning_months"
        :items="learningMonthItems"
        item-text="text"
        item-value="value"
        label="受講期間（月）"
        required
        dense
        outlined
        hide-details="auto"
        v-model="learningMonths"
      ></v-select>
      <input
        v-if="showLearningMonths"
        type="hidden"
        name="learning_months"
        :value="learningMonths"
      >
    </v-flex>
    <v-flex>
      <label class="datepicker-label">受講開始希望日</label>
      <vuejs-datepicker
        name="learning_start_at"
        format="yyyy-MM-dd"
        :language="datepickerJa"
        class="datepicker"
        :disabled-dates="disabledDates"
        v-model="StartDate"
      ></vuejs-datepicker>
      <div class="alert" v-if="error">{{ error }}</div>
      <input type="hidden" name="learning_start_at" :value="formattedStartDate">
    </v-flex>
  </v-layout>
</template>

<script>
import vuejsDatePicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    'vuejs-datepicker': vuejsDatePicker
  },
  props: {
    paymentMethod: {
      type: [String, Number],
      required: true
    },
    error: {
      type: String,
      default: ''
    },
    initialStartDate: {
      type: String,
      default: ''
    },
    learningMonthItems: {
      type: Array,
      default: () => []
    },
    initialLearningMonths: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return {
      StartDate: null,
      learningMonths: this.initialLearningMonths,
      datepickerJa: ja,
      disabledDates: {
        to: today
      }
    }
  },
  computed: {
    isVisible () {
      return parseInt(this.paymentMethod) === 2;
    },
    showLearningMonths() {
      return this.isVisible && this.learningMonthItems.length > 0
    },
    formattedStartDate() {
      if (!this.StartDate) return '';

      const year = this.StartDate.getFullYear();
      const month = ('0' + (this.StartDate.getMonth() + 1)).slice(-2);
      const day = ('0' + this.StartDate.getDate()).slice(-2);
      return `${year}-${month}-${day}`; // → "2025-04-30" 形式に整形
    }
  },
  mounted() {
    if (this.initialStartDate) {
      this.StartDate = new Date(this.initialStartDate);
    }

    if (this.initialLearningMonths) {
      this.learningMonths = Number(this.initialLearningMonths);
    }
  },
  watch: {
    initialLearningMonths(newVal) {
      this.learningMonths = Number(newVal);
    },
  }
}
</script>

<style lang="scss" scoped>
  .datepicker {
    border-bottom: 1px solid #555;
    width: 200px;
    font-size: 1.1rem;
    &-label {
      font-size: 1rem;
      color: #555;
    }
  }

  .alert {
    color: #e3342f;
    font-size: 1rem;
  }

  .payment-radio .v-messages .theme--light {
    margin-bottom: 20px;
  }
</style>
